import api from '@pray/shared/utils/api';

/**
 * Fetch analytics data for an offer
 *
 * @param {Object} params
 * @param {string} params.artistId - The artist UUID
 * @param {string} params.offerId - The offer UUID
 * @param {string} [params.startDate] - Start date (YYYY-MM-DD)
 * @param {string} [params.endDate] - End date (YYYY-MM-DD)
 * @returns {Promise<Object>} Analytics data
 */
export async function getOfferAnalytics({ artistId, offerId, startDate, endDate }) {
  if (!offerId) throw new Error('Offer ID is required');

  let url = `/web/studio/offers/${offerId}/analytics`;

  const params = new URLSearchParams();
  params.append('artist_id', artistId);
  if (startDate) params.append('start_date', startDate);
  if (endDate) params.append('end_date', endDate);

  const queryString = params.toString();
  if (queryString) {
    url += `?${queryString}`;
  }

  const response = await api.executeGetRequest(url);

  return response.data;
}
